import styled from 'styled-components';

import { txt } from '../../../../locales/i18n';
import { Form, FormInstance, Input, Select } from 'antd';

export type PostsPanelPanelProps = {
	propertyKey: string;
	formRef: React.RefObject<FormInstance>;
	onSectionChange: (changedValues: any, values: any) => void;
};

export const PostsPanel = (props: PostsPanelPanelProps) => {
	return (
		<PostsPanelStyled>
			<div className="row-container">
				<div className="form-item-container">
					<label>{txt('cms.title')}</label>
					<Form.Item name={[props.propertyKey, 'titleColor']}>
						<Input type="color" />
					</Form.Item>
				</div>

				<div className="form-item-container">
					<label>{txt('cms.paragraph')}</label>
					<Form.Item name={[props.propertyKey, 'textColor']}>
						<Input type="color" />
					</Form.Item>
				</div>
			</div>

			<label>{txt('cms.postIds.dk')}</label>
			<Form.Item name={[props.propertyKey, 'postIds', 'dk']}>
				<Select tokenSeparators={[',', ' ']} mode="tags" style={{ width: '100%' }} />
			</Form.Item>
		</PostsPanelStyled>
	);
};

const PostsPanelStyled = styled.div`
	.row-container {
		display: flex;
		gap: 2ch;
	}

	.form-item-container {
		flex: 1;
	}
`;
